type TrailLocation = { pathname: string; search: string; key: string };

type TrailEntry = {
  event: string;
  path?: string;
  params?: string[];
  at: number;
};

const MAX_ENTRIES = 15;
const trail: TrailEntry[] = [];
const last = { location: '' };

const push = (entry: TrailEntry) => {
  trail.push(entry);
  if (trail.length > MAX_ENTRIES) trail.shift();
};

export const recordNavigation = (location: TrailLocation, action: string) => {
  const id = [location.key, location.pathname, location.search].join('|');
  if (id === last.location) return;
  // eslint-disable-next-line immutable/no-mutation
  last.location = id;
  push({
    event: action.toLowerCase(),
    path: location.pathname,
    params: [...new URLSearchParams(location.search).keys()],
    at: Date.now(),
  });
};

export const startNavigationTrail = (
  location: TrailLocation,
  subscribe: (listener: (location: TrailLocation, action: string) => void) => void,
) => {
  recordNavigation(location, 'initial');
  subscribe(recordNavigation);
  document.addEventListener('visibilitychange', () => {
    push({ event: document.hidden ? 'hidden' : 'visible', at: Date.now() });
  });
};

export const getNavigationTrail = () => {
  const now = Date.now();
  return trail.map(({ at, ...entry }) => ({ ...entry, secondsAgo: Math.round((now - at) / 1000) }));
};

export const getPageLoadType = () =>
  (performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined)?.type;
